import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import api from '../services/api';
import socketService from '../services/socketService';
import '../styles/AdminComponents.css';

const DEFAULT_INSTANCE = 'bda-notificacoes';

function WhatsAppSetup({ tenantId }) {
  const [status, setStatus] = useState({ connected: false, phoneNumber: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkStatus();
    const interval = setInterval(checkStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    socketService.onWhatsAppStatus((data) => {
      if (data.instance === DEFAULT_INSTANCE) {
        setStatus({ connected: data.connected, phoneNumber: data.phoneNumber });
      }
    });

    return () => {
      socketService.off('whatsapp:status');
    };
  }, []);

  const checkStatus = async () => {
    try {
      const response = await api.get(`/whatsapp/status/${DEFAULT_INSTANCE}`);
      setStatus(response.data);
    } catch (error) {
      console.error('Erro ao verificar status:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-component">
      <h2>WhatsApp — Instância: <code>{DEFAULT_INSTANCE}</code></h2>

      <div className="status-card" style={{ marginTop: '20px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
            <RefreshCw size={32} style={{ animation: 'spin 1s linear infinite' }} />
            <p style={{ marginTop: '10px' }}>Verificando status...</p>
          </div>
        ) : (
          <div className="status-indicator">
            {status.connected ? (
              <>
                <Wifi className="status-icon connected" size={40} style={{ color: '#22c55e' }} />
                <div style={{ marginLeft: '16px' }}>
                  <h3 style={{ color: '#22c55e', margin: 0 }}>✅ Conectado</h3>
                  <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                    {status.phoneNumber || 'Número não disponível'}
                  </p>
                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#999' }}>
                    Instância: <strong>{DEFAULT_INSTANCE}</strong>
                  </p>
                </div>
              </>
            ) : (
              <>
                <WifiOff className="status-icon disconnected" size={40} style={{ color: '#ef4444' }} />
                <div style={{ marginLeft: '16px' }}>
                  <h3 style={{ color: '#ef4444', margin: 0 }}>❌ Desconectado</h3>
                  <p style={{ margin: '4px 0 0 0', color: '#666' }}>
                    A instância <strong>{DEFAULT_INSTANCE}</strong> não está conectada.
                  </p>
                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#999' }}>
                    Conecte a instância diretamente no painel do Evolution Manager.
                  </p>
                </div>
              </>
            )}

            <button
              onClick={checkStatus}
              style={{
                marginLeft: 'auto',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 16px',
                background: '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              <RefreshCw size={16} />
              Atualizar Status
            </button>
          </div>
        )}
      </div>

      <div style={{
        marginTop: '24px',
        padding: '16px',
        background: '#f0fdf4',
        border: '1px solid #bbf7d0',
        borderRadius: '8px'
      }}>
        <h4 style={{ margin: '0 0 8px 0', color: '#166534' }}>ℹ️ Como funciona</h4>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#166534', fontSize: '14px' }}>
          <li>A instância <strong>{DEFAULT_INSTANCE}</strong> já está conectada via Evolution Manager</li>
          <li>Mensagens recebidas aparecem automaticamente em <strong>Conversas</strong></li>
          <li>O status é atualizado a cada 10 segundos</li>
        </ul>
      </div>
    </div>
  );
}

export default WhatsAppSetup;
